import { ExamCenterMemberStatus } from '@exam-center/exam-center-member-details';
import { type SearchAvailableExamCenterManagerUsersQuery } from '@exam-center/graphql';
import { dayjs } from '@shared/utils';

type UserForExamCenterQueryResult =
  SearchAvailableExamCenterManagerUsersQuery['ecSearchAvailableExamCenterManagerUsers']['users'][number];

function mapStatus(status: string, invitationExpireAt: string | null) {
  if (status === 'INVITATION_PENDING' && dayjs(invitationExpireAt).isBefore(dayjs())) {
    return ExamCenterMemberStatus.INVITATION_EXPIRED;
  }
  return status as ExamCenterMemberStatus;
}

export default function mapUserForExamCenterData(users: UserForExamCenterQueryResult) {
  const { id, firstname, lastname, email, appRoles, status, invitationExpireAt } = users;
  const fullName = `${firstname} ${lastname}`;

  if (!email) {
    throw new Error('Email is required');
  } else if (!appRoles) {
    throw new Error('User App Role is required');
  } else if (!status) {
    throw new Error('User Status is required');
  }

  return {
    id: id,
    fullName: fullName,
    email: email,
    role: appRoles,
    status: mapStatus(status, invitationExpireAt),
  };
}
